import { reduxSocketTypes } from 'src/types';
import {
  INSERT_SOCKET_MESSAGE,
  SURFER_STATE_CHANGED,
  SURFER_ADDRESS_CHANGED,
  MMU_CONNECTION_STATE_CHANGED,
  HYMOTSE_STARTED,
} from 'src/app/redux/redux-types';

export const socketDefaultState: reduxSocketTypes.StateType = {
  messages: [],
  surferAddress: undefined,
  isSurferOn: undefined,
  MMUStatus: undefined,
  hymotseStarted: false,
  hymotseConnected: false,
};

export const socketReducer = (
  state = socketDefaultState,
  action: reduxSocketTypes.ActionType,
): reduxSocketTypes.StateType => {
  switch (action.type) {
    case INSERT_SOCKET_MESSAGE:
      state.messages.unshift(action.payload);
      return {
        ...state,
      };
    case SURFER_STATE_CHANGED:
      return {
        ...state,
        isSurferOn: action.payload,
      };

    case SURFER_ADDRESS_CHANGED:
      if (action.payload) {
        const { protokol: protocol, ip, port } = action.payload;

        return {
          ...state,
          surferAddress: `${protocol}://${ip}:${port}`,
        };
      }

      return {
        ...state,
        surferAddress: undefined,
      };

    case MMU_CONNECTION_STATE_CHANGED:
      return {
        ...state,
        MMUStatus: action.payload,
      };
    case HYMOTSE_STARTED:
      return {
        ...state,
        hymotseStarted: action.payload,
      };
    case 'HYMOTSE_CONNECTED':
      return {
        ...state,
        hymotseConnected: action.payload,
      };
    default:
      return state;
  }
};
